export default {
  budgets: 'Orçamentos {from}%–{to}%',
  reference: 'Referência {value} {unit}',
  ready: 'Pronta',
  running: 'Calculando simulação...',
  createdBy: 'Criada por',
  on: 'em',
  clone: 'Clonar',
  edit: 'Editar',
  editWhenDone: 'Pode ser editada quando todos os orçamentos estiverem calculados',
  settings: 'Configurações',
  showToExternalUsers: 'Mostrar para usuários externos',
  save: 'Salvar',
  printJsonToConsole: 'Imprimir JSON no console',
  viewMore: 'Ver mais',
  viewMoreWhenDone: 'Disponível quando todos os orçamentos estiverem calculados'
}
